import { utility } from '@phi/components';
import {
    filtered_indicated_vertices,
    moving_coordinates_visible,
    selected_coordinates_visible,
} from '../../state';
import { defineComponent, h } from 'vue';
import { VertexComponent } from '../vertex';

export const VertexIndicator = defineComponent({
    render() {
        if (moving_coordinates_visible.value || selected_coordinates_visible.value)
            return h('div', { class: [ 'moving-vertices-indicator', utility.no_interact ] },
                filtered_indicated_vertices
                    .value
                    .map((x) => h(VertexComponent, { vertex: x })));
        else
            return '';
    },
});
